var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBethistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.375 7.59961C6.375 9.61749 7.99263 11.2666 10 11.2666C12.0074 11.2666 13.625 9.61749 13.625 7.59961V2.0332H6.375V7.59961ZM2 6.33301C2 7.30272 2.77701 8.09961 3.75 8.09961H4.875V3.93359H2V6.33301ZM15.125 8.09961H16.25C17.223 8.09961 18 7.30272 18 6.33301V3.93359H15.125V8.09961ZM9.25 12.7578L8.86328 12.667C7.36738 12.3182 6.10253 11.3091 5.41797 9.91309L5.28027 9.63379H3.75C1.96049 9.63379 0.5 8.16263 0.5 6.33301V3.16699C0.5 2.73704 0.84174 2.40039 1.25 2.40039H4.875V0.5H15.125V2.40039H18.75C19.1583 2.40039 19.5 2.73704 19.5 3.16699V6.33301C19.5 8.16263 18.0395 9.63379 16.25 9.63379H14.7197L14.582 9.91309C13.8975 11.3091 12.6326 12.3182 11.1367 12.667L10.75 12.7578V16.9668H15.125V18.5H4.875V16.9668H9.25V12.7578Z",
    fill: "#DC3A3F",
    stroke: "#E13E3F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBethistory);
export default __webpack_public_path__ + "static/media/bethistory.737874e0a75d1bcb92d91bfdcf4a150a.svg";
export { ForwardRef as ReactComponent };